const isValidEmail = email => {
  // eslint-disable-next-line no-useless-escape
  const EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  return EMAIL_REGEX.test(email)
}

export default isValidEmail
